import React from 'react';
import { InvoiceDetailContainer } from '../../../containers';

export const InvoiceDetail = () => <InvoiceDetailContainer />;
